<script lang="ts">
    import { onDestroy } from "svelte";
    import { LL } from "../../../../i18n/i18n-svelte";
    import { mapEditorTileBrushToolStore, type TileBrushTool } from "../../../Stores/MapEditorStore";
    import { IconPencil, IconEraser, IconBucket, IconRectangle, IconWall, IconColorPicker } from "@wa-icons";

    let selected = $state<TileBrushTool>("pencil");

    const unsubscriber = mapEditorTileBrushToolStore.subscribe((value) => {
        selected = value;
    });

    onDestroy(() => {
        unsubscriber();
    });

    function select(brush: TileBrushTool) {
        mapEditorTileBrushToolStore.set(brush);
    }

    function label(brush: TileBrushTool): string {
        switch (brush) {
            case "pencil":
                return $LL.mapEditor.tilemapEditor.pencil();
            case "eraser":
                return $LL.mapEditor.tilemapEditor.eraser();
            case "fill":
                return $LL.mapEditor.tilemapEditor.fill();
            case "rect":
                return $LL.mapEditor.tilemapEditor.rect();
            case "collision":
                return $LL.mapEditor.tilemapEditor.collision();
            case "eyedropper":
                return $LL.mapEditor.tilemapEditor.eyedropper();
        }
    }
</script>

<div class="flex flex-col gap-2">
    <h4 class="text-sm font-semibold">{$LL.mapEditor.tilemapEditor.tools()}</h4>
    <div class="flex gap-1">
        <button
            type="button"
            class="p-2 rounded {selected === 'pencil' ? 'bg-secondary' : 'bg-white/10 hover:bg-white/20'}"
            title={label("pencil")}
            aria-label={label("pencil")}
            onclick={() => select("pencil")}
        >
            <IconPencil font-size="16" />
        </button>
        <button
            type="button"
            class="p-2 rounded {selected === 'eraser' ? 'bg-secondary' : 'bg-white/10 hover:bg-white/20'}"
            title={label("eraser")}
            aria-label={label("eraser")}
            onclick={() => select("eraser")}
        >
            <IconEraser font-size="16" />
        </button>
        <button
            type="button"
            class="p-2 rounded {selected === 'fill' ? 'bg-secondary' : 'bg-white/10 hover:bg-white/20'}"
            title={label("fill")}
            aria-label={label("fill")}
            onclick={() => select("fill")}
        >
            <IconBucket font-size="16" />
        </button>
        <button
            type="button"
            class="p-2 rounded {selected === 'rect' ? 'bg-secondary' : 'bg-white/10 hover:bg-white/20'}"
            title={label("rect")}
            aria-label={label("rect")}
            onclick={() => select("rect")}
        >
            <IconRectangle font-size="16" />
        </button>
        <button
            type="button"
            class="p-2 rounded {selected === 'collision' ? 'bg-secondary' : 'bg-white/10 hover:bg-white/20'}"
            title={label("collision")}
            aria-label={label("collision")}
            onclick={() => select("collision")}
        >
            <IconWall font-size="16" />
        </button>
        <button
            type="button"
            class="p-2 rounded {selected === 'eyedropper' ? 'bg-secondary' : 'bg-white/10 hover:bg-white/20'}"
            title={label("eyedropper")}
            aria-label={label("eyedropper")}
            onclick={() => select("eyedropper")}
        >
            <IconColorPicker font-size="16" />
        </button>
    </div>
</div>
